<div class="popup-header"> {{headerTitle}}</div>


<table class="popup-table">
    <thead>
        <tr><th>Date</th><th class="center">Day</th><th class="center">Sales</th><th class="center">Svinn</th></tr>
    </thead>
    <tbody>
        @for (day of dayData; track day.date) {
            <tr><td>{{day.date}}</td><td class="center">{{day.day}}</td><td class="center">{{day.sales}}</td><td class="center">{{day.svinn}}</td></tr>
        }

        <tr class="popup-total-row"><td colspan="2"><strong>Total</strong></td><td class="center"><strong>{{totals.sales}}</strong></td><td class="center"><strong>{{totals.svinn}}</strong></td></tr>
        <tr><td colspan="2"><strong>Median</strong></td><td class="center">{{totals.salesMedian}}</td><td class="center">{{totals.svinnMedian}}</td></tr>
        <tr><td colspan="2"><strong>Max</strong></td><td class="center">{{totals.salesMax}}</td><td class="center">{{totals.svinnMax}}</td></tr>
        <tr><td colspan="3"></td><td class="center">{{totals.percent}}%</td></tr>
        <!-- optional empty-state row if needed -->
        <tr class="popup-empty" *ngIf="!dayData || dayData.length === 0">
            <td colspan="4">No data available</td>
        </tr>
    </tbody>
</table>


<button type="button" mat-raised-button (click)="closeDialog()">Close</button>
